import { render, staticRenderFns } from "./echange-stock.html?vue&type=template&id=03713906&scoped=true&external"
import script from "./echange-stock.js?vue&type=script&lang=js&external"
export * from "./echange-stock.js?vue&type=script&lang=js&external"
import style0 from "./echange-stock.scss?vue&type=style&index=0&id=03713906&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03713906",
  null
  
)

export default component.exports